import Skeleton from "react-loading-skeleton";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../../../utils/constants";

const SkeletonBlock = ({
  width = "100%",
  height,
  circle = false,
  className = "",
}: {
  width?: string | number;
  height: string | number;
  circle?: boolean;
  className?: string;
}) => (
  <Skeleton
    width={width}
    height={height}
    circle={circle}
    baseColor={SKELETON_BASE_COLOR}
    highlightColor={SKELETON_HIGHLIGHT_COLOR}
    className={circle ? className : `rounded-lg ${className}`}
  />
);

const OrganizerLoader = ({ className = "" }: { className?: string }) => (
  <div className={`flex flex-col gap-12 ${className}`}>
    <div className="flex w-full flex-col items-center justify-center gap-5">
      <SkeletonBlock width={100} height={14} />

      <div className="flex w-full items-center gap-[10px]">
        <SkeletonBlock width={32} height={32} circle />
        <SkeletonBlock width={140} height={20} />
      </div>
    </div>

    <div className="flex flex-col items-start gap-5">
      <SkeletonBlock width={90} height={14} />

      <div className="flex flex-wrap items-start gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <SkeletonBlock key={i} width={34} height={34} />
        ))}
      </div>
    </div>
  </div>
);

export const PreviewLoader = () => {
  return (
    <div className="relative flex w-full flex-col gap-8 pb-10 md:flex-row md:flex-wrap md:items-start md:justify-center md:gap-10">
      <div className="flex w-full flex-col gap-[72px] md:max-w-[500px]">
        <SkeletonBlock height={300} className="!h-[300px] w-full md:!h-[472px]" />

        <OrganizerLoader className="hidden lg:flex" />
      </div>

      <div className="flex w-full flex-col gap-8 md:max-w-[530px]">
        <div className="flex flex-col gap-12">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-2">
                <SkeletonBlock width={"80%"} height={38} />

                <div className="flex items-center gap-2">
                  <div className="flex items-center">
                    <SkeletonBlock
                      width={20}
                      height={20}
                      circle
                      className="relative z-[1] -mr-2"
                    />
                    <SkeletonBlock width={20} height={20} circle />
                  </div>
                  <SkeletonBlock width={150} height={20} />
                </div>
              </div>

              <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2">
                  <SkeletonBlock width={34} height={34} />
                  <SkeletonBlock width={"70%"} height={20} />
                </div>
                <div className="flex items-center gap-2">
                  <SkeletonBlock width={34} height={34} />
                  <SkeletonBlock width={"50%"} height={20} />
                </div>
                <div className="flex items-center gap-2">
                  <SkeletonBlock width={34} height={34} />
                  <SkeletonBlock width={"85%"} height={20} />
                </div>
              </div>
            </div>

            <div className="flex w-full flex-col gap-[18px] rounded-lg border border-grey-100 px-[14px] pb-5 pt-[14px]">
              <SkeletonBlock width={120} height={16} />

              <div className="flex w-full flex-col gap-6">
                <div className="flex flex-col gap-3">
                  <SkeletonBlock height={72} />
                  <SkeletonBlock height={72} />
                </div>

                <SkeletonBlock height={48} />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-12">
            <div className="flex flex-col gap-5">
              <SkeletonBlock width={100} height={16} />

              <div className="flex flex-col gap-2">
                <SkeletonBlock height={20} />
                <SkeletonBlock height={20} />
                <SkeletonBlock width={"70%"} height={20} />
              </div>
            </div>

            <div className="flex flex-col gap-5">
              <SkeletonBlock width={70} height={16} />

              <div className="flex items-center gap-3">
                <SkeletonBlock width={40} height={40} />
                <div className="flex flex-1 flex-col gap-2">
                  <SkeletonBlock width={"60%"} height={20} />
                  <SkeletonBlock width={"85%"} height={16} />
                </div>
              </div>

              <SkeletonBlock height={220} />
            </div>
          </div>
        </div>

        <OrganizerLoader className="flex lg:hidden" />
      </div>
    </div>
  );
};
